import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getSolicitudClase, checkoutSolicitudClase } from '../lib/api';
import { st } from '../lib/solicitudesTxt';

export default function ClaseParticular() {
  const { token } = useParams();
  const [sp] = useSearchParams();
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || 'es').toLowerCase();
  const T = (k) => st(lang, k);
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);
  const [pagando, setPagando] = useState(false);

  useEffect(() => {
    let vivo = true;
    const cargar = () => getSolicitudClase(token).then((r) => vivo && setS(r.solicitud)).catch(() => vivo && setErr(true));
    cargar();
    // Tras volver de Stripe el webhook puede tardar unos segundos.
    const t = sp.get('stripe') === 'success' ? setInterval(cargar, 3000) : null;
    const stop = t ? setTimeout(() => clearInterval(t), 30000) : null;
    return () => { vivo = false; if (t) clearInterval(t); if (stop) clearTimeout(stop); };
  }, [token, sp]);

  async function pagar() {
    setPagando(true);
    try { const r = await checkoutSolicitudClase(token); window.location.href = r.url; }
    catch { setPagando(false); setErr(true); }
  }

  if (err && !s) return <main className="horarios-page"><header className="horarios-head"><h1 className="horarios-titulo">{T('p_no')}</h1></header></main>;
  if (!s) return <main className="horarios-page"><header className="horarios-head"><p className="horarios-sub">{T('p_cargando')}</p></header></main>;

  const f = s.fecha_confirmada || s.fecha_deseada;
  const h = s.hora_confirmada || s.hora_deseada;
  const titulo = { pendiente: 'p_pend_t', confirmada: 'p_conf_t', pagada: 'p_pag_t', rechazada: 'p_rech_t', cancelada: 'p_rech_t' }[s.estado];
  const texto = { pendiente: 'p_pend_p', confirmada: 'p_conf_p', pagada: 'p_pag_p', rechazada: 'p_rech_p', cancelada: 'p_rech_p' }[s.estado];
  return (
    <main className="horarios-page">
      <header className="horarios-head">
        <h1 className="horarios-titulo">{T(titulo)}</h1>
        <p className="horarios-sub">{T(texto)}</p>
        <p><strong>{T('l_cuando')}:</strong> {new Date(`${String(f).slice(0, 10)}T00:00:00`).toLocaleDateString(lang, { weekday: 'long', day: 'numeric', month: 'long' })} · {h} · {s.modalidad === 'online' ? T('online') : T('presencial')} · {s.num_personas} {T('personas').toLowerCase()}</p>
        {s.importe_euros != null && <p><strong>{T('l_importe')}:</strong> {Number(s.importe_euros).toFixed(2)} €</p>}
        {s.nota_anya && <p><strong>{T('l_nota')}:</strong> {s.nota_anya}</p>}
        {sp.get('stripe') === 'cancelled' && s.estado === 'confirmada' && <p className="modal-error-general">{T('p_cancel')}</p>}
        {s.estado === 'confirmada' && (
          <button type="button" className="btn-primary" onClick={pagar} disabled={pagando}>{pagando ? T('p_pagando') : T('p_pagar')}</button>
        )}
      </header>
    </main>
  );
}
